// @ts-nocheck
import {createContext,useContext} from "react";

export const FormularioContext = createContext({});
export function useFormulario() {
    return useContext(FormularioContext);
}
